var _style, _ellipse, _ellipse2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _rect2, _line, _circle7, _circle8, _circle9, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle0, _circle1, _circle10, _rect0, _polyline, _line2, _circle11, _circle12, _circle13, _rect1, _circle14, _circle15, _circle16, _rect10, _line3, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _polygon, _ellipse3, _ellipse4, _polygon2, _path, _path2, _path3, _path4, _path5, _circle23, _path6, _path7, _path8, _path9, _path0, _polygon3, _ellipse5, _ellipse6, _polygon4, _polygon5, _ellipse7, _ellipse8, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e66cdcae-b662-46fb-b424-18ba1a805fb0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "282.3 -304.9 1000 710",
    style: {
      enableBackground: "new 282.3 -304.9 1000 710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E03997;}\n\t.st1{fill:none;stroke:#3F3D56;stroke-miterlimit:10;}\n\t.st2{fill:#F86B75;}\n\t.st3{fill:#FAD375;}\n\t.st4{fill:#8BCC55;}\n\t.st5{fill:#F2F2F2;}\n\t.st6{fill:#79758C;}\n\t.st7{fill:#3F3D56;}\n\t.st8{fill:#A0616A;}\n\t.st9{fill:#55536E;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bookmarks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 1033,
    cy: 355,
    rx: 151,
    ry: 34
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 1047,
    cy: 345,
    rx: 151,
    ry: 34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 802.5,
    cy: 15.5,
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 923.5,
    cy: 15.5,
    r: 30
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1044.5,
    cy: 15.5,
    r: 30
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 378.5,
    cy: -268.5,
    r: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 387.5,
    cy: -268.5,
    r: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 396.5,
    cy: -268.5,
    r: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: -222,
    className: "st0",
    width: 206,
    height: 64
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 366.5,
    y: -278.5,
    className: "st1",
    width: 364,
    height: 216
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 366.5,
    y1: -262.1,
    x2: 730.5,
    y2: -262.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 379.5,
    cy: -270.5,
    r: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 388.5,
    cy: -270.5,
    r: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 397.5,
    cy: -270.5,
    r: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 445.5,
    y: -234.5,
    className: "st1",
    width: 206,
    height: 64
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: -130,
    className: "st5",
    width: 276,
    height: 8.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: -110.1,
    className: "st5",
    width: 276,
    height: 8.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: -90.3,
    className: "st5",
    width: 276,
    height: 8.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: -134,
    className: "st1",
    width: 276,
    height: 8.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: -114.1,
    className: "st1",
    width: 276,
    height: 8.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: -94.3,
    className: "st1",
    width: 276,
    height: 8.3
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 462.5,
    cy: 105.5,
    r: 3
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 471.5,
    cy: 105.5,
    r: 3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 480.5,
    cy: 105.5,
    r: 3
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 152,
    className: "st0",
    width: 206,
    height: 64
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "814.5,139.5 814.5,311.5 450.5,311.5 450.5,95.5 746.5,95.5 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 450.5,
    y1: 111.9,
    x2: 747,
    y2: 111.9
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 463.5,
    cy: 103.5,
    r: 3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 472.5,
    cy: 103.5,
    r: 3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 481.5,
    cy: 103.5,
    r: 3
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 529.5,
    y: 139.5,
    className: "st1",
    width: 206,
    height: 64
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 758.5,
    cy: -67.5,
    r: 3
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 767.5,
    cy: -67.5,
    r: 3
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 776.5,
    cy: -67.5,
    r: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 746.5,
    y: -77.5,
    className: "st1",
    width: 364,
    height: 216
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 746.5,
    y1: -61.1,
    x2: 1110.5,
    y2: -61.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 759.5,
    cy: -69.5,
    r: 3
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 768.5,
    cy: -69.5,
    r: 3
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 777.5,
    cy: -69.5,
    r: 3
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 807.5,
    cy: 10.5,
    r: 30
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 928.5,
    cy: 10.5,
    r: 30
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1049.5,
    cy: 10.5,
    r: 30
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 762,
    y: 66,
    className: "st5",
    width: 82,
    height: 8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 884,
    y: 66,
    className: "st5",
    width: 82,
    height: 8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1006,
    y: 66,
    className: "st5",
    width: 82,
    height: 8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 766,
    y: 63,
    className: "st1",
    width: 82,
    height: 8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 888,
    y: 63,
    className: "st1",
    width: 82,
    height: 8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1010,
    y: 63,
    className: "st1",
    width: 82,
    height: 8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 241,
    className: "st5",
    width: 63,
    height: 54
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 580.5,
    y: 241.5,
    className: "st5",
    width: 63,
    height: 54
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 697,
    y: 242,
    className: "st5",
    width: 63,
    height: 54
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 231,
    className: "st1",
    width: 63,
    height: 54
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 589.5,
    y: 231.5,
    className: "st1",
    width: 63,
    height: 54
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 706,
    y: 232,
    className: "st1",
    width: 63,
    height: 54
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "966.8,-84.4 938.7,-68.8 968.7,-79.4 "
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3089 -0.9511 0.9511 -0.3089 1355.5679 816.8686)",
    className: "st7",
    cx: 974.6,
    cy: -84.1,
    rx: 15.8,
    ry: 7.8
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3089 -0.9511 0.9511 -0.3089 1398.9497 824.3378)",
    className: "st7",
    cx: 999,
    cy: -96.1,
    rx: 11.1,
    ry: 5.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "976.4,-93.2 995,-99.9 998.9,-88.9 980.9,-76.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M974.6-52.9l5-11c0,0,12-32,1-26s-15,22-15,22l-3,10L974.6-52.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1111.6,113.1c0,0-17,33-22,34s-5-30-5-30s10-9,14-8S1111.6,113.1,1111.6,113.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1086.6,321.1c0,0,9,5,5,16s-6,8-8,17s-20,8-21,4s-3-20,2-26S1086.6,321.1,1086.6,321.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M997.6,321.1c0,0-9,5-5,16s6,8,8,17s20,8,21,4s3-20-2-26C1014.6,326.1,997.6,321.1,997.6,321.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1081.6,121.1c0,0,8,5,10,36s-1,66-2,74s1,20,3,26s-5,52-5,52c3,6.3,3,13.7,0,20c-5,11-20,22-24,11 c-0.2-3.8-1.2-7.6-3-11c-3-6,2-30,2-30s-4-38-3-48s-12-69-14-79s-1-18-2-15s-19,86-19,86s2,53,1,60s4,21,1,26c-3,5-9,23-20,12 s-9-15-10-20s0-11,0-19s-8-53-4-60s2-16,1-32s-2-93,8-107S1081.6,121.1,1081.6,121.1z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 1057.1,
    cy: -90.4,
    r: 24
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1072.6-80.9c0,0-1,36,4,42s-43-5-43-5s11-23,4-38S1072.6-80.9,1072.6-80.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1081.6-42.9c0,0-2-8-14-10s-26.2-4-30.6,0s-6.4,9-9.4,9h-14l-22,39c0,0,11,13,8,37s-8,68-8,68 c8,10.7,15,22.1,21,34c10,20,79,18,75-17c0,0-5-9-3-17s8-62,8-62l23-61C1115.6-22.9,1083.6-38.9,1081.6-42.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1108.6-23.9h7c0,0,4,23,3,37s-1,47-1,47s4,8,3,15s-3,26-3,26s-1,27-20,13c0,0-6-3-3-16s-2-27-2-27s3-9,2-15 s-5-25-5-25L1108.6-23.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1018.6-40.9l-5-3c0,0-7-3-17,0s-15,2-19,1s-1-11-1-11s-8-14-16-6s-8,24-8,24s-5,10,13,16s26,15,26,15h20 L1018.6-40.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1055.5-61.7c-0.1-1.8-1.2-3.4-2.9-4.1c-1.1-0.4-2.3-0.6-3.4-0.7c-3.4-0.4-6.9-1.7-8.9-4.3 c-2.6-3.5-1.9-8.3-4-12.1c-1-1.5-2.1-2.9-3.2-4.2c-3.7-4.9-4.3-11.3-4.7-17.3c-0.2-1.2,0-2.5,0.4-3.6c0.6-1,1.4-2,2.3-2.8 c1.5-1.7,2.3-4,2.3-6.2c-0.1-4.7,6.5-7.8,11.3-9.4s9.8-1.9,14.8-1.9c2.9,0,5.9,0,8.5,1c1.5,0.7,3,1.5,4.3,2.5 c5.6,4.1,10.8,9.1,12.6,15.4c0.7,2.9,1.1,5.9,1,8.8c0.1,0.9,0,1.9-0.4,2.7c-0.7,1.3-2.2,2.1-3.3,3.2c-1.9,2.1-1.6,5.2-1.8,7.9 c-0.6,5.8-3.9,10.9-8.9,13.8c-1,0.5-2,1.2-2.8,1.9c-0.6,0.8-1.1,1.7-1.5,2.7C1065.1-64.4,1060.1-61.9,1055.5-61.7z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "558.6,-278.2 545.3,-270.8 559.5,-275.8 "
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3089 -0.9511 0.9511 -0.3089 1000.4253 170.8618)",
    className: "st7",
    cx: 562.3,
    cy: -278,
    rx: 7.5,
    ry: 3.7
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3089 -0.9511 0.9511 -0.3089 1021.0178 174.4073)",
    className: "st7",
    cx: 573.9,
    cy: -283.7,
    rx: 5.3,
    ry: 2.8
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "563.1,-282.4 572,-285.5 573.9,-280.3 565.3,-274.6 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "648.6,93.8 635.3,101.2 649.5,96.2 "
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3089 -0.9511 0.9511 -0.3089 764.4236 743.3785)",
    className: "st7",
    cx: 652.3,
    cy: 94,
    rx: 7.5,
    ry: 3.7
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3089 -0.9511 0.9511 -0.3089 785.0162 746.924)",
    className: "st7",
    cx: 663.9,
    cy: 88.3,
    rx: 5.3,
    ry: 2.8
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "653.1,89.6 662,86.5 663.9,91.7 655.3,97.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider3);
export default __webpack_public_path__ + "static/media/slider3.35545e9074d235ecee81e144e851a5ae.svg";
export { ForwardRef as ReactComponent };